/**
 * Sanitize and truncate an error message before rendering it inline in the UI.
 *
 * Runtime/probe error envelopes can embed URLs that carry shared-access tokens
 * or tenant identifiers, and they can be arbitrarily long. We replace any
 * URL-looking substring with `<url>` and cap the result so a verbose trace
 * can't leak secrets or overflow a panel.
 *
 * @param message Raw error text (already coerced to a string by the caller).
 * @returns A trimmed, URL-stripped message capped at 240 characters. If the
 *   message exceeds 240 characters it is truncated to 240 and a trailing
 *   ellipsis is appended, so the returned string is at most 241 characters.
 */
export function sanitizeErrorMessage(message: string): string {
  const stripped = message.replace(/https?:\/\/\S+/gi, '<url>');
  const trimmed = stripped.trim();
  if (trimmed.length <= 240) return trimmed;
  return `${trimmed.slice(0, 240)}…`;
}
